<template>
  <div class="container-fluid">
    <card>
        <object v-bind:id="'dash-' + settings.id" v-bind:data="iframeUrl" width="100%" height="1200" type="text/html">
          O servidor de relatórios parece estar fora do ar!
        </object>
    </card> 
  </div>
</template>

<script>
import {ref, watch} from "vue";
import jwt from 'jsonwebtoken';

export default {
  name: 'ShowDashboard',
  props: {
    settings: {
      type: Object
    }
  },
  components: {
  },
  data() {
    return {
    }
  },
  setup(props) {

    const iframeUrl = ref('')
    const METABASE_SITE_URL = ref('')
    const METABASE_SECRET_KEY = ref('')

    function buildDashboard(dashboard_id) {
      let payload = {
        resource: {dashboard: parseInt(dashboard_id)},
        params: {}
      };
      let token = jwt.sign(payload,
          METABASE_SECRET_KEY.value,
      );

      iframeUrl.value = METABASE_SITE_URL.value + "/embed/dashboard/" + token + "#bordered=true&titled=true";
    }

    watch(
        () => props.settings,
        () => {
          METABASE_SITE_URL.value = props.settings.url
          METABASE_SECRET_KEY.value = props.settings.secret_key
          buildDashboard(props.settings.id.toString())
        }
    )


    return {
      iframeUrl,
      METABASE_SITE_URL,
      METABASE_SECRET_KEY
    }
  }
}
</script>

<style lang="scss" scoped>

</style>


